import { ETaxDocTypeGroup, ETaxNote } from "../../../types/e-tax.type";

/** The types the notes list holds, in the order the confirmation dialog counts them. */
export const NOTE_DOC_TYPES: readonly ETaxDocTypeGroup[] = ["DN", "CN"];

/** A note whose document is already out has no reason to wait: it simply is not sendable again. */
export const NOTE_ALREADY_SENT_REASON = "ส่ง e-Tax ไปแล้ว ไม่ต้องส่งซ้ำ";

type NoteReasonFields = Pick<
  ETaxNote,
  "etax_enabled" | "etax_paper_reason_message" | "etax_reason_messages"
>;

/**
 * Why the note is not going to e-Tax, one line each. A paper note says why it is paper: the gate
 * also lists "this note is paper" and, for a note on a paper bill, "the original bill is not
 * signed", and neither would help the reader there.
 */
export const getNoteReasonLines = (note: NoteReasonFields): string[] => {
  if (!note.etax_enabled && note.etax_paper_reason_message) {
    return [note.etax_paper_reason_message];
  }
  return note.etax_reason_messages;
};

/**
 * Why this note cannot be picked for sending, or null when it can. The server decides
 * (`can_send`); this only words it for the disabled checkbox.
 */
export const getNoteUnsendableReason = (
  note: NoteReasonFields & Pick<ETaxNote, "can_send">,
): string | null => {
  if (note.can_send) return null;
  const lines = getNoteReasonLines(note);
  return lines.length > 0 ? lines.join(" · ") : NOTE_ALREADY_SENT_REASON;
};

export const toNoteBatchItem = (note: Pick<ETaxNote, "transaction_uuid">) => ({
  transaction_uuid: note.transaction_uuid,
});
